import { render, staticRenderFns } from "./EditGrupo.vue?vue&type=template&id=62130cb0"
import script from "./EditGrupo.vue?vue&type=script&lang=js"
export * from "./EditGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports